


































import Vue from 'vue'
import { AdditionalGroup } from '@/model/additional-fields/AdditionalGroup'
import Select from '@/components/additional-fields/AdditionalFieldsSelect.vue'
import Check from '@/components/additional-fields/AdditionalFieldsCheck.vue'
import NumberField from '@/components/additional-fields/AdditionalFieldsNumber.vue'
import FieldsText from '@/components/additional-fields/AdditionalFieldsText.vue'
import Textarea from '@/components/additional-fields/AdditionalFieldsTextArea.vue'
import Email from '@/components/additional-fields/AdditionalFieldsEmail.vue'
import FieldsDatePicker from '@/components/additional-fields/AdditionalFieldsDatePicker.vue'
import SelectMultiple from '@/components/additional-fields/AdditionalFieldsSelectMultiple.vue'
import {
  FETCH_PROFIT_CENTER_ADDITIONAL,
  SAVE_PROFIT_CENTER_ADDITIONAL
} from '@/store/action-types'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'
import {
  AdditionalFieldsPayloadItem,
  ProfitCenterAdditionalFieldsUpdatePayload
} from '@/types/payload'
import { AdditionalField } from '@/model/additional-fields/AdditionalField'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import DecimalNumber from '@/components/additional-fields/AdditionalFieldsDecimalNumber.vue'
import { ProfitCenterAdditionalFieldsGetItemResponse, ResponseBase } from '@/types/service-response'
import MultiLanguageTextArea
  from '@/components/additional-fields/AdditionalFieldsMultiLanguageTextArea.vue'

interface ComponentData {
  active: number[]
  treeItemList: AdditionalGroup[] | null
  componentTypeMap: Map<number, string>
  selectedData: AdditionalFieldItem[]
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
}

export default Vue.extend({
  name: 'ProfitCenterAdditionalFields',

  components: {
    Select,
    NumberField,
    FieldsText,
    Check,
    Textarea,
    Email,
    FieldsDatePicker,
    SelectMultiple,
    DecimalNumber,
    MultiLanguageTextArea
  },

  props: {
    profitCenterId: Number
  },

  data (): ComponentData {
    return {
      active: [],
      treeItemList: [],
      componentTypeMap: new Map([
        [2, 'Select'], [4, 'DecimalNumber'], [1, 'FieldsText'], [21, 'Textarea'], [3, 'Check'], [6, 'Email'], [11, 'FieldsDatePicker'], [5, 'SelectMultiple'], [8, 'MultiLanguageTextArea']
      ]),
      selectedData: [],
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false
    }
  },

  watch: {
    profitCenterId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.treeItemList = []
        this.selectedData = []
        this.fetchAdditionalData()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    }
  },

  methods: {
    onValueChange (data: AdditionalFieldItem): void {
      const foundData: AdditionalFieldItem | undefined = this.selectedData.find((item: AdditionalFieldItem) => item.parentType === data.parentType)
      if(foundData) {
        const index: number = this.selectedData.indexOf(foundData)
        this.selectedData.splice(index, 1, data)
      } else {
        this.selectedData.push(data)
      }

      if(this.treeItemList) {
        this.treeItemList.forEach((group: AdditionalGroup) => {
          if (group.id === data.groupId) {
            group.children.forEach((field: AdditionalField, idx: number) => {
              if (field.type === data.parentType) {
                const updatedField: AdditionalField = AdditionalField.updateValue(field, data.value)
                group.children.splice(idx, 1, updatedField)
              }
            })
          }
        })
      }
    },

    onSaveButtonClick (): void {
      const fields: AdditionalFieldsPayloadItem[] = this.selectedData.map((item: AdditionalFieldItem) => {
        return {"Feldtyp": item.parentType, "Art": item.componentId, "Value": item.value}
      })

      const payload: ProfitCenterAdditionalFieldsUpdatePayload = {
        ProfitCenter: this.profitCenterId,
        Data: fields,
      }
      this.saveAdditionalFields(payload)
    },

    async saveAdditionalFields (payload: ProfitCenterAdditionalFieldsUpdatePayload): Promise<void> {
      try {
        this.loading = true
        const response: ResponseBase = await this.$store.dispatch(SAVE_PROFIT_CENTER_ADDITIONAL, payload)
        this.loading = false
        this.selectedData = []
        if(response && !response.IsError) {
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          await this.fetchAdditionalData()
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch (e) {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchAdditionalData (): Promise<void> {
      try {
        const response: ProfitCenterAdditionalFieldsGetItemResponse = await this.$store.dispatch(FETCH_PROFIT_CENTER_ADDITIONAL, this.profitCenterId)
        if(!response.IsError && response.Tree) {
          this.treeItemList = AdditionalGroup.createFromResponse(response.Tree)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  mounted () {
    this.fetchAdditionalData()
  }

})
